import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';


import "./utils/pxrem"
Vue.use(ElementUI);

import "./assets/res.less"


import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

Vue.use(VueAwesomeSwiper);

// 1. 导入懒加载插件
import VueLazyload from 'vue-lazyload'

// 2. 注册插件（可配置默认加载图/错误图，便于排查）
Vue.use(VueLazyload, {
  preLoad: 1.2, // 预加载高度比例
  // error: require('@/assets/loading.webp'), // 图片加载失败时显示
  // loading: require('@/assets/loading.webp'), // 图片加载中显示
  attempt: 1 // 加载失败重试次数
})

router.beforeEach((to,from,next)=>{
  console.log(to);
  window.scrollTo(0, 0);
  var ua = window.navigator.userAgent
  if (!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua))) {
    // window.location.href = `https://njybt.com/${to.name}`
  } else if (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0) {
    window.location.href = `https://njybt.com/yibaotongMobile/#/${to.name}`
  }
  next()

})
router.afterEach((to) => {
  window.scrollTo(0, 0);//切花路由使得滚动条在顶端
  document.title=to.meta.name ||"南京壹宝通信息技术有限公司"  //配置浏览器上的标题

})






Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
  // bus总线的写法
  beforeCreate() {
    Vue.prototype.$bus = this //将bus添加到Vue添加构造函数的原型 全局事件总线
  }
}).$mount("#app");
